import React, { Component } from 'react';
import { Modal, message, Radio, DatePicker, Button, Upload } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import ExportUtil from '../../../common/ExportUtil';
import UserDetail from '../../investigation/UserDetail';
import moment from 'moment';

const RadioGroup = Radio.Group;

class RegisterBidding extends Component {
    state = {
        params: {},
        nativeFileList: [], //原生file
        visible: false,
        loading: false,
        isEdit: false,
    }

    show = (record = {}) => {
        const { evaluateRecordId, evaluateCode } = record;
        this.setState({
            params: {
                evaluateRecordId,
                evaluateCode,
            },
            visible: true,
        }, () => {
            this.queryEvaluateRecordBidding();
        });
    }

    queryEvaluateRecordBidding = () => {
        const { params: { evaluateCode } } = this.state;
        if (!evaluateCode) {
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateRecordBidding,
            data: {
                evaluateCode
            },
            dataType: 'json',
            doneResult: res => {
                const { evaluateRecordBidding } = res;
                const {
                    biddingFlag,
                    biddingDate,
                    id,
                    userId,
                    ossFileList,
                    employeeCode,
                    userName,
                } = evaluateRecordBidding || {};

                const { params } = this.state;
                (ossFileList || []).map(el => {
                    this.downloadEvaluateRecordBiddingFile(el.id, el.fileName);
                });
                params.biddingFlag = (biddingFlag === null || biddingFlag === undefined) ? 'true' : String(biddingFlag);
                params.biddingDate = biddingDate;
                params.id = id;
                params.userId = userId;
                params.ossFileList = ossFileList;
                params.employeeCode = employeeCode;
                params.userName = userName;
                params.userNameShow = (userName && employeeCode) ? `${userName}[${employeeCode}]` : undefined;
                this.setState({
                    params
                })
            }
        };
        $.sendRequest(options);
    }

    downloadEvaluateRecordBiddingFile = (id, filename) => {
        if (!id) {
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.downloadEvaluateRecordBiddingFile,
            data: {
                fileId: id,
            },
            dataType: 'json',
            doneResult: res => {
                const { fileStr } = res;
                this.base64ToFile(fileStr, id, filename);
            }
        };
        $.sendRequest(options);
    }

    base64ToFile = async (base64String = '', id, filename) => {
        // 如果 base64 字符串包含 data URL 前缀，先提取纯 base64 部分
        let base64Content = base64String;

        // 如果包含 data URL 前缀，如 "data:image/png;base64,"
        if (base64String.includes('base64,')) {
            base64Content = base64String.split('base64,')[1];
        }

        try {
            // 1. 将 base64 字符串转换为二进制数据
            const response = await fetch(`data:${'application/octet-stream'};base64,${base64Content}`);

            // 2. 获取 blob 对象
            const blob = await response.blob();

            // 3. 创建 File 对象
            const file = new File([blob], filename, {
                type: 'application/octet-stream',
                lastModified: Date.now()
            });
            file.uid = id;
            const { nativeFileList } = this.state;
            this.setState({
                nativeFileList: [
                    ...nativeFileList,
                    file,
                ]
            });
        } catch (error) {
            console.error('转换失败:', error);
            throw error;
        }
    }

    hide = () => {
        this.setState({
            params: {},
            visible: false,
            loading: false,
            isEdit: false,
            nativeFileList: [], 
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        switch (key) {
            case 'biddingFlag':
                params[key] = value;
                params.userId = undefined;
                params.userName = undefined;
                params.userNameShow = undefined;
                params.biddingDate = undefined;
                params.ossFileList = [];
                break;
            case 'user':
                const { value: id, text: name } = value;
                params.userId = id;
                params.userName = name;
                params.userNameShow = name;
                break;
            default:
                params[key] = value;
                break;
        }
        this.setState({ params });
    }

    beforeUpload = (file) => {
        const { nativeFileList } = this.state;
        const isLt50M = file.size / 1024 / 1024 <= 50;
        if (nativeFileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt50M) {
            message.warning('文件大小不能超过50M');
            return false;
        }
        this.setState({
            nativeFileList: [
                ...nativeFileList,
                file,
            ]
        })
        return false
    }

    handleRemove = (file) => {
        const { nativeFileList } = this.state;
        const index = nativeFileList.indexOf(file);
        const newNativeFileList = nativeFileList.slice();
        newNativeFileList.splice(index, 1);
        this.setState({ nativeFileList: newNativeFileList });
    }

    downLoadFile = (fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    downLoadOssFile = (id) => {
        const url = API_URL.contract.downloadOssFile;
        ExportUtil.export({ id }, null, url);
    }

    submit = () => {
        const { params, nativeFileList } = this.state;
        const { biddingFlag, userId, biddingDate, evaluateRecordId, id } = params;

        //校验必填
        if (biddingFlag == 'true' && !userId) {
            return message.warning('请选择竞标人');
        }
        if (biddingFlag == 'true' && !biddingDate) {
            return message.warning('请选择竞标日期');
        }
        const fromData = new FormData();
        (nativeFileList || []).map((file, index) => {
            fromData.append(`files[${index}]`, file)
        });
        fromData.append('curUserId', sessionStorage.userId);
        fromData.append('curRoleCode', sessionStorage.curRole);
        fromData.append('curEmployeeCode', sessionStorage.curEmployeeCode || '');

        fromData.append('evaluateRecordId', evaluateRecordId);
        fromData.append('evaluateCode', params.evaluateCode);
        fromData.append('biddingFlag', biddingFlag);
        !!userId && fromData.append('userId', userId);
        !!biddingDate && fromData.append('biddingDate', biddingDate);
        if (id) fromData.append('id', id);
        this.setState({ loading: true });
        //id有值，说明是修改，不是添加
        const url = id ? API_URL.evaluate.updateEvaluateRecordBidding : API_URL.evaluate.addEvaluateRecordBidding;
        fetch(url, {
            method: 'post',
            body: fromData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                ...xToken,
            }
        }).then(res => {
            if (res.ok) {
                return res.json();
            }
        }).then(data => {
            if (data.error) {
                message.error(data.error);
                this.setState({ loading: false });
            } else {
                message.success(data.success);
                this.hide();
                this.props.loadData();
            }
        }).catch(err => {
            message.error(err);
            this.setState({ loading: false });
        });
    }

    edit = (value) => {
        // const { params } = this.state;
        this.setState({ isEdit: value });
    }

    render() {
        const { visible, params, loading, isEdit, nativeFileList } = this.state;
        const { biddingFlag, userId, userName, userNameShow, employeeCode, biddingDate, ossFileList = [] } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={'登记竞标'}
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width="450px"
                footer={isEdit ? <span>
                    <Button style={{ maginRight: 10 }} onClick={() => this.edit(false)}>取消</Button>
                    <Button type="primary" onClick={this.submit}>确定</Button>
                </span>
                    : <Button type="primary" onClick={() => this.edit(true)}>编辑</Button>
                }
            >
                <div className="modal-content" style={{ padding: '10px 30px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{asterisk}是否竞标：</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {
                                    isEdit ?
                                        <RadioGroup
                                            value={biddingFlag}
                                            onChange={e => this.handleChange(e.target.value, 'biddingFlag')}
                                        >
                                            <Radio key={'true'} value={'true'}>是</Radio>
                                            <Radio key={'false'} value={'false'}>否</Radio>
                                        </RadioGroup>
                                        : (biddingFlag == 'true' ? '是' : '否')
                                }
                            </div>
                        </li>
                        {biddingFlag === 'true' &&
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '40%' }}>{asterisk}竞标人：</div>
                                <div className="item-right" style={{ width: '60%' }}>
                                    {isEdit ?
                                        <SearchRetrieve
                                            keyword='keyword'
                                            style={{ width: 180 }}
                                            value={userNameShow}
                                            params={{ limit: 20, dimissionStatus: 'WORKING' }}
                                            placeholder="输入姓名/工号检索"
                                            url={API_URL.investigation.queryUserByKey}
                                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                            onChange={option => this.handleChange(option, 'user')}
                                        /> :
                                        <a onClick={() => this.UserDetailRef.show(userId)}>
                                            {(userName && employeeCode) &&
                                                `${userName}[${employeeCode}]`
                                            }
                                        </a>
                                    }
                                </div>
                            </li>
                        }
                        {biddingFlag === 'true' &&
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '40%' }}>{asterisk}竞标日期：</div>
                                <div className="item-right" style={{ width: '60%' }}>
                                    {isEdit ?
                                        <DatePicker
                                            format={'YYYY-MM-DD'}
                                            value={biddingDate ? moment(biddingDate) : null}
                                            style={{ width: 180 }}
                                            allowClear={true}
                                            placeholder="请选择竞标日期"
                                            onChange={(date, dateString) => this.handleChange(dateString, 'biddingDate')}
                                        /> : biddingDate
                                    }
                                </div>
                            </li>
                        }
                        {biddingFlag === 'true' &&
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '40%' }}>竞标附件：</div>
                                <div className="item-right" style={{ width: '60%' }}>
                                    {
                                        isEdit ?
                                            <Upload
                                                data={{
                                                    curUserId: sessionStorage.userId,
                                                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                                }}
                                                fileList={nativeFileList}
                                                beforeUpload={this.beforeUpload}
                                                onRemove={this.handleRemove}
                                                headers={xToken}
                                            >
                                                <Button style={{ width: 80 }}>选择文件</Button>
                                            </Upload>
                                            :
                                            (ossFileList || []).map(el => <a onClick={() => this.downLoadOssFile(el.id)}>{el.fileName}<br /></a>)
                                    }
                                </div>
                            </li>
                        }
                    </ul>
                </div>
                <UserDetail
                    ref={el => this.UserDetailRef = el}
                />
            </Modal>
        );
    }
        }

export default RegisterBidding;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/RegisterBidding.js